import React from 'react';
import {isEmpty} from 'lodash';

import GroupProductsUI from "../components/GroupItems/GroupProductsUI";
import PropTypes from "prop-types";
import {CurrentAgentContext} from "../../contexts/CurrentAgentContext";

const isDev = (process.env.NODE_ENV === 'development');

/**
 * 2025-02 this was massive, now it's tiny! Refactored to GroupPageContainer & GroupVehicleWatcher
 *
 * @param id
 * @param loading
 * @param props
 * @param pageConfig
 * @param currentAgent null or {id, username}
 * @returns {JSX.Element}
 * @constructor
 */
export default function GroupProductsContainer({
  id = 'product-section',  // important: ScrollToProductsButton uses this.
  loading = false,
  pageConfig = {productSection: {}},
  currentAgent = null,

  allProductSpecs,
  dispatch,
  // cartCode groupId pageType productGroup groupProperties shoppingCart dynamicCart
  // customerVehicle vehicleContext allClusterStates renderedBy group
  // productAttributes products productDetail clusterIndex itemApplications allApps
  ...props
}) {
  let hasNothing = isEmpty(props.products);

  if (loading || hasNothing) {
    return <GroupProductsPlaceholder id={id} cartConfig={props.cartConfig} pageConfig={pageConfig}/>
  }

  // deprecated: <EmptyProductsSection id={id} loading={loading} {...props}/>
  return <section id={id} className="clearfix">
    <CurrentAgentContext.Provider value={currentAgent}>
      <GroupProductsUI
        pageConfig={pageConfig}
        allProductSpecs={allProductSpecs}
        {...props} />
    </CurrentAgentContext.Provider>
  </section>
}

GroupProductsContainer.propTypes = {
  // static - from the Rails template, via GroupProductsApp
  groupProperties: PropTypes.object.isRequired,
  productGroup: PropTypes.object.isRequired,
  customerVehicle: PropTypes.object,
}

function GroupProductsPlaceholder({id, cartConfig, pageConfig}) {
  if (isDev) {
    return <div className="debug">products not loaded
      <pre><code>{JSON.stringify(cartConfig, null, 4)}</code></pre>
      <div>{JSON.stringify(pageConfig, null, 2)}</div>
    </div>
  }

  return <section id={id} className="clearfix"></section>
}
